import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { ModalService } from './p-modal.service';

@Component({
  selector: 'p-modal',
  templateUrl: './p-modal.component.html',
  styleUrls: ['./p-modal.component.scss'],
})
export class PModalComponent implements OnDestroy {
  @Input() modalId: string = '';
  @Input() title: string = '';
  @Input() canClose: boolean = true;
  @Output() cancel = new EventEmitter<void>();

  constructor(private modalService: ModalService) {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-overflow-hidden');
  }

  ngOnDestroy(): void {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('body-overflow-hidden');
  }

  closeModal() {
    this.modalService.hideModal();
    this.cancel.emit();
  }

  onCancel() {
    this.cancel.emit();
    this.modalService.hideModal();
  }
}
